import React, { useContext, useState, useEffect } from 'react'
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined'
import HeaderContext from '../../context/HeaderContext'
import LocationContext from '../../context/LocationContext'
import classes from './Header.module.css'
import Menu from './Menu'
import { SupportIcon } from '../../components/UI/Icons/Icons'
import { useNavigate } from 'react-router-dom'

const HeaderTransparent = () => {
  const {
    title,
    userInfo,
    iconWhite,
    setIconWhite,
    onHeaderBack,
    headerSurface
  } = useContext(HeaderContext)
  const { previousLocation, currentLocation } = useContext(LocationContext)
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()

  const showMembershipIcon =
    userInfo?.subscription?.is_active &&
    currentLocation.pathname === '/detalles-membresia'

  const toggleDrawer = () => {
    setOpen(!open)
  }

  useEffect(() => {
    if (
      ((previousLocation.pathname === '/detalles-membresia' &&
        currentLocation.pathname !== previousLocation?.pathname) ||
        (previousLocation.pathname === '/detalles-plan' &&
          currentLocation.pathname !== previousLocation?.pathname)) &&
      iconWhite
    ) {
      setIconWhite(false)
    }
  }, [iconWhite, currentLocation, previousLocation, setIconWhite])

  const headerClassName = [
    classes.Header,
    headerSurface ? classes.scheduleSurface : classes.transparent,
    !headerSurface && onHeaderBack ? classes.transparentWithBack : null
  ]
    .filter(Boolean)
    .join(' ')

  const headerStyle = headerSurface
    ? { backgroundColor: headerSurface }
    : undefined

  const supportLink = (
    <a
      id="btnContact"
      target="_blank"
      rel="noopener noreferrer"
      href={`https://wa.me/525543658774?text=¡Hola,%20soy%20${
        userInfo && userInfo.name
      }%20Tengo%20una%20duda...`}
    >
      <SupportIcon
        className={`${classes.icon} ${iconWhite && classes.iconWhite}`}
      />
    </a>
  )

  return (
    <>
      <Menu open={open} toggleDrawer={toggleDrawer} />

      <header className={headerClassName} style={headerStyle}>
        {onHeaderBack
          ? (
              <button
                type="button"
                className={classes.headerBackButton}
                onClick={onHeaderBack}
                aria-label="Regresar"
              >
                <ArrowBackIosNewOutlinedIcon className={classes.iconBack} />
              </button>
            )
          : (
              <span className={classes.headerSideSpacer} aria-hidden="true" />
            )}

        {title && <h2 className={classes.title}>{title}</h2>}

        <div className={classes.headerTrailing}>
          {showMembershipIcon
            ? (
                <div>
                  <img
                    src={userInfo?.subscription?.icon}
                    alt={userInfo?.subscription?.name}
                    className={classes.icon}
                    style={{ padding: '16px 0px' }}
                    onClick={() => navigate('/plan-actual')}
                  />
                  {supportLink}
                </div>
              )
            : (
                supportLink
              )}
        </div>
      </header>
    </>
  )
}

export default HeaderTransparent
